import { stripLanguagePrefix } from "@/utils";

interface IShouldBlockGroupMembersNavigationParams {
  skipUnsavedChangesPrompt: boolean;
  hasUnsavedChanges: boolean;
  currentPathname: string;
  nextPathname: string;
}

export function shouldBlockGroupMembersNavigation({
  skipUnsavedChangesPrompt,
  hasUnsavedChanges,
  currentPathname,
  nextPathname,
}: IShouldBlockGroupMembersNavigationParams): boolean {
  if (skipUnsavedChangesPrompt) return false;
  if (!hasUnsavedChanges) return false;

  const currentPath = stripLanguagePrefix(currentPathname);
  const nextPath = stripLanguagePrefix(nextPathname);
  return currentPath !== nextPath;
}
